// vendor styles
import 'normalize.css/normalize.css'

// website specific styles and scripts
import './styles/common.scss'
import './styles/contact.scss'
import './scripts/contact.js'



/** WEBPACK FOOTER **
 ** ./assets/contact.js
 **/